import apiClient from "@/features/dashboard/api/axios";
import { TrendingBrandsQuery } from "@/features/dashboard/features/trending-brand-section/types";

const url = {
  getTrendingBrands: () => "/dashboards/best-brands",
};

export const dashboardTrendingBrandsApi = {
  getTrendingBrands: async (params: TrendingBrandsQuery) =>
    await apiClient.get(url.getTrendingBrands(), {
      params,
    }),
};
